import PropTypes from "prop-types"
import { useState, Fragment, memo } from "react"
import { RingLoader } from "../../shared/components/Spinner"
import styled from "styled-components"
import { cartType } from "./types"

const List = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(134px, 1fr));
  grid-gap: 40px;
  max-width: 700px;
  margin-top: 12px;
  width: 100%;
  list-style: none;
  padding: 0;
  margin-left: 0;
  margin-right: 0;
  min-height: 140px;

  li {
    position: relative;
  }
`

const Img = styled.img`
  width: 100%;
  cursor: pointer;
  visibility: ${(p) => (p.isLoaded ? "visible" : "hidden")};
`

const Cart = ({ angled_image_url, name, onClick }) => {
  const [isLoaded, setLoaded] = useState(false)
  return (
    <Fragment>
      {!isLoaded ? <RingLoader color="black" overlay={false} /> : null}
      <Img
        onClick={onClick}
        onLoad={() => setLoaded(true)}
        isLoaded={isLoaded}
        src={angled_image_url}
        alt={name}
      />
    </Fragment>
  )
}

const CartList = ({ items, onClick }) => {
  return (
    <List>
      {items.map((item) => (
        <li key={item.id} hidden={!item.display}>
          <Cart {...item} onClick={() => onClick(item)} />
        </li>
      ))}
    </List>
  )
}

CartList.propTypes = {
  onCLick: PropTypes.func,
  items: PropTypes.arrayOf(cartType),
}

export default memo(CartList)
